{
    "onthejobtraining": {
        "Baslik": "On The Job Training",
        "Kullanici": "Kullanıcı",
        "Musteri": "Müşteri",
        "Tarih": "Tarih",
        "Durum": "Durum",
        "Gorus": "Görüş",
        "Not": "Not",
        "Degerlendirme": "Değerlendirme",
        "RandevuDetayi": "Randevu Detayı",
        "RandevuTarihi": "Randevu Tarihi",
        "RandevuSonucu": "Randevu Sonucu",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "Kaydet": "Kayıt",
        "KaydetKapat": "Kayıt-Kapat",
        "Bekliyor": "Görüş Bekleniyor",
        "GorusAldi": "Cevap Yazıldı",
        "Tamamlandi": "Kapalı",
        "EminMisiniz": "Emin misiniz?",
        "SilmeMesaj": "Bunu geri alamazsınız!",
        "Hepsi": "Hepsi"
    }
}
